import { InjectionToken } from '@angular/core';
import { Api, ApiConfig } from 'bimplus-websdk';

/**
 * Injection token for the Bimplus API instance.
 */
export const BIMPLUS_API = new InjectionToken<Api>('BIMPLUS_API');

/**
 * Injection token for the Bimplus API configuration.
 */
export const BIMPLUS_API_CONFIG = new InjectionToken<ApiConfig>('BIMPLUS_API_CONFIG');
